import { AdvancedStyleState, SettingsModel, SettingsState } from '@/components/layout/SettingsModel';
import { AdvancedStyleData, PopupPositionType, SettingsData } from '@/typings/interfaces/data/settings/settings';
import store from '@/store';
import { CampaignModel } from '@/models/CampaignModel';
import { VisibilityConditionsData } from '@/typings/interfaces/data/conditions/visibilityConditions';
import { InlineElement, InlineHeightEnum } from './typing/interfaces';

export class FlowPageSettingsModel extends SettingsModel {
  constructAdvancedStyleState(data: AdvancedStyleData): AdvancedStyleState {
    const style = super.constructAdvancedStyleState(data);
    const campaignModel = store.getters['campaign/model'] as CampaignModel;

    if (campaignModel.state.isPopup) {
      style.margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };

      const position = this.state.basic?.position?.type ?? PopupPositionType.BOTTOM_LEFT;
      const positionX = this.state.basic?.position?.x ?? 0;
      const positionY = this.state.basic?.position?.y ?? 0;

      switch (position) {
        case 'top_left':
          style.margin.left = positionX;
          style.margin.top = positionY;
          break;

        case 'top_center':
          style.margin.left = 0;
          style.margin.top = positionY;
          break;

        case 'top_right':
          style.margin.right = positionX;
          style.margin.top = positionY;
          break;

        case 'center_center':
          style.margin.left = 0;
          style.margin.top = 0;
          break;

        case 'bottom_left':
          style.margin.left = positionX;
          style.margin.bottom = positionY;
          break;

        case 'bottom_center':
          style.margin.left = 0;
          style.margin.bottom = positionY;
          break;

        case 'bottom_right':
          style.margin.right = positionX;
          style.margin.bottom = positionY;
          break;
      }
    }

    return style;
  }

  protected constructElementInlineStyles(state: SettingsState): InlineElement {
    const inlineStyle = super.constructElementInlineStyles(state);

    if (state.basic?.height?.type === 'fixed' && state.basic.height.fixed) {
      inlineStyle.height = {
        type: InlineHeightEnum.FIXED,
        value: state.basic.height.fixed
      };
    } else if (state.basic?.height?.type === 'window') {
      inlineStyle.height = {
        type: InlineHeightEnum.WINDOW
      };
      inlineStyle.overflowY = 'auto';
      inlineStyle.overflowX = 'hidden';
    }

    return inlineStyle;
  }

  public getDefaultPadding() {
    return 30;
  }

  protected constructVisibilityConditionData(data: SettingsData): VisibilityConditionsData {
    // Type casting to number so that '0' as a string doesn't get seen as enabled.
    const showOnDesktop = Number(data.show_on_desktop ?? '1') ? '1' : '0';
    const showOnMobile = Number(data.show_on_mobile ?? '1') ? '1' : '0';

    return {
      ...(data.advanced?.visibility_condition ?? {}),
      devices: {
        desktop: showOnDesktop,
        tablet: showOnDesktop,
        mobile: showOnMobile
      }
    };
  }

  authorSignature(): string {
    return 'Dannie Hansen';
  }
}
